module.exports = __webpack_public_path__ + "img/en_5.d3e85ee6.jpg";